'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _get = require('lodash/get');
var _omitBy = require('lodash/omitBy');
var _isEmpty = require('lodash/isEmpty');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _omitBy__default = /*#__PURE__*/_interopDefaultLegacy(_omitBy);
var _isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(_isEmpty);

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var REQUIRED_VARIABLES = ['APP_URL'];
var ENV_NAMES = {
  LOCAL: 'local',
  DEV: 'dev',
  STG: 'staging',
  PERF: 'perf',
  DR: 'dr',
  PREPROD: 'pre-prod',
  PROD: 'prod'
};

var doesAppUrlMatchOrigin = function doesAppUrlMatchOrigin(_ref) {
  var appUrl = _ref.appUrl,
      origin = _ref.origin;

  if (typeof appUrl === 'string' || appUrl instanceof String) {
    return appUrl === origin;
  }

  return appUrl == null ? void 0 : appUrl.includes(origin);
};

var getEnv = function getEnv(env) {
  var _DEV$ENV, _STAGING$ENV, _PERF$ENV, _DR$ENV, _PREPROD$ENV, _LOCAL$ENV, _PROD$ENV;

  var LOCAL = {
    ENV: _objectSpread({}, (env == null ? void 0 : env._global) || {}, {}, (env == null ? void 0 : env.local) || {}, {
      ENV_NAME: ENV_NAMES.LOCAL,
      FUNDER_URL: 'https://dev-funder.medipass.io',
      CONNECT_URL: 'https://dev-connect.medipass.io',
      CONSUMER_URL: 'https://dev-my.medipass.io',
      ACCOUNTS_URL: 'https://dev-accounts.medipass.io',
      QUOTES_URL: 'https://dev-quotes.medipass.io',
      CHECKOUT_URL: 'https://dev-checkout.medipass.io'
    })
  };
  var DEV = {
    ENV: _objectSpread({}, (env == null ? void 0 : env._global) || {}, {}, (env == null ? void 0 : env.dev) || {}, {
      ENV_NAME: ENV_NAMES.DEV,
      FUNDER_URL: 'https://dev-funder.medipass.io',
      CONNECT_URL: 'https://dev-connect.medipass.io',
      CONSUMER_URL: 'https://dev-my.medipass.io',
      ACCOUNTS_URL: 'https://dev-accounts.medipass.io',
      QUOTES_URL: 'https://dev-quotes.medipass.io',
      CHECKOUT_URL: 'https://dev-checkout.medipass.io'
    })
  };
  var STAGING = {
    ENV: _objectSpread({}, (env == null ? void 0 : env._global) || {}, {}, (env == null ? void 0 : env.staging) || {}, {
      ENV_NAME: ENV_NAMES.STG,
      FUNDER_URL: 'https://stg-funder.medipass.io',
      CONNECT_URL: 'https://stg-connect.medipass.io',
      CONSUMER_URL: 'https://stg-my.medipass.io',
      ACCOUNTS_URL: 'https://stg-accounts.medipass.io',
      QUOTES_URL: 'https://stg-quotes.medipass.io',
      CHECKOUT_URL: 'https://stg-checkout.medipass.io'
    })
  };
  var PERF = {
    ENV: _objectSpread({}, (env == null ? void 0 : env._global) || {}, {}, (env == null ? void 0 : env.perf) || {}, {
      ENV_NAME: ENV_NAMES.PERF,
      FUNDER_URL: 'https://perf-funder.medipass.io',
      CONNECT_URL: 'https://perf-connect.medipass.io',
      CONSUMER_URL: 'https://perf-my.medipass.io',
      ACCOUNTS_URL: 'https://perf-accounts.medipass.io',
      QUOTES_URL: 'https://perf-quotes.medipass.io',
      CHECKOUT_URL: 'https://perf-checkout.medipass.io'
    })
  };
  var DR = {
    ENV: _objectSpread({}, (env == null ? void 0 : env._global) || {}, {}, (env == null ? void 0 : env.dr) || {}, {
      ENV_NAME: ENV_NAMES.DR,
      FUNDER_URL: 'https://dr-funder.medipass.io',
      CONNECT_URL: 'https://dr-connect.medipass.io',
      CONSUMER_URL: 'https://dr-my.medipass.io',
      ACCOUNTS_URL: 'https://dr-accounts.medipass.io',
      QUOTES_URL: 'https://dr-quotes.medipass.io',
      CHECKOUT_URL: 'https://dr-checkout.medipass.io'
    })
  };
  var PREPROD = {
    ENV: _objectSpread({}, (env == null ? void 0 : env._global) || {}, {}, (env == null ? void 0 : env.preprod) || {}, {
      ENV_NAME: ENV_NAMES.PREPROD,
      FUNDER_URL: 'https://funder-blue.medipass.io',
      CONNECT_URL: 'https://connect-blue.medipass.io',
      CONSUMER_URL: 'https://my-blue.medipass.io',
      ACCOUNTS_URL: 'https://accounts-blue.medipass.io',
      QUOTES_URL: 'https://quotes-blue.medipass.io',
      CHECKOUT_URL: 'https://checkout-blue.medipass.io'
    })
  };
  var PROD = {
    ENV: _objectSpread({}, (env == null ? void 0 : env._global) || {}, {}, (env == null ? void 0 : env.prod) || {}, {
      ENV_NAME: ENV_NAMES.PROD,
      FUNDER_URL: 'https://funder.medipass.io',
      CONNECT_URL: 'https://connect.medipass.io',
      CONSUMER_URL: 'https://my.medipass.io',
      ACCOUNTS_URL: 'https://accounts.medipass.io',
      QUOTES_URL: 'https://quotes.medipass.io',
      CHECKOUT_URL: 'https://checkout.medipass.io'
    })
  };

  var fabSettings = _get__default["default"](window, 'FAB_SETTINGS', {});

  var origin = window.location.origin;

  if (process.env.REACT_APP_ENV === 'dev' || fabSettings.REACT_APP_ENV === 'dev' || doesAppUrlMatchOrigin({
    appUrl: (DEV == null ? void 0 : (_DEV$ENV = DEV.ENV) == null ? void 0 : _DEV$ENV.APP_URL) || '',
    origin: origin
  })) {
    return DEV.ENV;
  } else if (process.env.REACT_APP_ENV === 'staging' || fabSettings.REACT_APP_ENV === 'staging' || doesAppUrlMatchOrigin({
    appUrl: (STAGING == null ? void 0 : (_STAGING$ENV = STAGING.ENV) == null ? void 0 : _STAGING$ENV.APP_URL) || '',
    origin: origin
  })) {
    return STAGING.ENV;
  } else if (process.env.REACT_APP_ENV === 'perf' || fabSettings.REACT_APP_ENV === 'perf' || doesAppUrlMatchOrigin({
    appUrl: (PERF == null ? void 0 : (_PERF$ENV = PERF.ENV) == null ? void 0 : _PERF$ENV.APP_URL) || '',
    origin: origin
  })) {
    return PERF.ENV;
  } else if (process.env.REACT_APP_ENV === 'dr' || fabSettings.REACT_APP_ENV === 'dr' || doesAppUrlMatchOrigin({
    appUrl: (DR == null ? void 0 : (_DR$ENV = DR.ENV) == null ? void 0 : _DR$ENV.APP_URL) || '',
    origin: origin
  })) {
    return DR.ENV;
  } else if (process.env.REACT_APP_ENV === 'pre-prod' || doesAppUrlMatchOrigin({
    appUrl: (PREPROD == null ? void 0 : (_PREPROD$ENV = PREPROD.ENV) == null ? void 0 : _PREPROD$ENV.APP_URL) || '',
    origin: origin
  })) {
    return PREPROD.ENV;
  } else if (process.env.REACT_APP_ENV === 'local' || doesAppUrlMatchOrigin({
    appUrl: (LOCAL == null ? void 0 : (_LOCAL$ENV = LOCAL.ENV) == null ? void 0 : _LOCAL$ENV.APP_URL) || '',
    origin: origin
  })) {
    return LOCAL.ENV;
  } else if (process.env.REACT_APP_ENV === 'prod' || doesAppUrlMatchOrigin({
    appUrl: (PROD == null ? void 0 : (_PROD$ENV = PROD.ENV) == null ? void 0 : _PROD$ENV.APP_URL) || '',
    origin: origin
  })) {
    return PROD.ENV;
  }

  return DEV.ENV;
};

var getEnvironmentsMissingVariables = function getEnvironmentsMissingVariables(envVariables) {
  var environmentsMissingVariables = [];

  for (var _iterator = _createForOfIteratorHelperLoose(REQUIRED_VARIABLES), _step; !(_step = _iterator()).done;) {
    var requiredVariable = _step.value;

    if (!envVariables[requiredVariable]) {
      environmentsMissingVariables = [].concat(environmentsMissingVariables, [requiredVariable]);
    }
  }

  return environmentsMissingVariables;
};

var getRequiredEnvironmentVariables = function getRequiredEnvironmentVariables(env) {
  var missingVariables = {};

  for (var key in env) {
    if (key.includes('_')) {
      continue;
    }

    if (Object.prototype.hasOwnProperty.call(env, key)) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      missingVariables[key] = getEnvironmentsMissingVariables(env[key]);
    }
  }

  return _omitBy__default["default"](missingVariables, _isEmpty__default["default"]);
};

var logWarningForMissingRequiredEnvironmentVariables = function logWarningForMissingRequiredEnvironmentVariables(missingRequiredEnvironmentVariables) {
  for (var key in missingRequiredEnvironmentVariables) {
    if (Object.prototype.hasOwnProperty.call(missingRequiredEnvironmentVariables, key)) {
      console.error("Warning: Required variables " + missingRequiredEnvironmentVariables[key] + " not defined in the '" + key + "' environment.");
    }
  }
};

var Env = /*#__PURE__*/function () {
  function Env() {
    this.ENV_NAME = null;
    this.FUNDER_URL = null;
    this.CONNECT_URL = null;
    this.CONSUMER_URL = null;
    this.ACCOUNTS_URL = null;
    this.QUOTES_URL = null;
    this.CHECKOUT_URL = null;
  }

  var _proto = Env.prototype;

  _proto.setup = function setup(env) {
    this.clear();
    var missingRequiredEnvironmentVariables = getRequiredEnvironmentVariables(env);
    logWarningForMissingRequiredEnvironmentVariables(missingRequiredEnvironmentVariables);
    var newEnv = getEnv(env);

    for (var key in newEnv) {
      if (Object.prototype.hasOwnProperty.call(newEnv, key)) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        this[key] = newEnv[key];
      }
    }
  };

  _proto.clear = function clear() {
    for (var key in this) {
      if (Object.prototype.hasOwnProperty.call(this, key)) {
        delete this[key];
      }
    }
  };

  return Env;
}();

var getEnv$1 = new Env();
var ERROR_MESSAGE__INTERNET_ERROR = process.env.REACT_APP_ERROR_MESSAGE__INTERNET_ERROR || 'We are unable to establish an internet connection. We will take you back once you are connected to the internet.';
var ERROR_MESSAGE__NETWORK_ERROR = process.env.REACT_APP_ERROR_MESSAGE__NETWORK_ERROR || 'There are issues connecting to the Tyro Health platform. Please refresh the page and try again.';
var ERROR_MESSAGE__SERVER_ERROR = process.env.REACT_APP_ERROR_MESSAGE__SERVER_ERROR || 'There are issues connecting to the Tyro Health platform. Please refresh the page and try again.';
var ERROR_MESSAGE__PAYMENT_GATEWAY_ERROR = process.env.REACT_APP_ERROR_MESSAGE__PAYMENT_GATEWAY_ERROR || 'There are issues connecting to the payment gateway. Please refresh the page and try again.';
var ERROR_MESSAGE__PAYMENT_ERROR = process.env.REACT_APP_ERROR_MESSAGE__PAYMENT_ERROR || 'An error occurred when processing the payment. Please try again. The card was not charged.';
var ERROR_MESSAGE__PAYMENT_GATEWAY_FIELDS = process.env.REACT_APP_ERROR_MESSAGE__PAYMENT_GATEWAY_FIELDS || 'The payment card details you entered were invalid, please review the payment card credentials and try again.';

exports.ENV_NAMES = ENV_NAMES;
exports.ERROR_MESSAGE__INTERNET_ERROR = ERROR_MESSAGE__INTERNET_ERROR;
exports.ERROR_MESSAGE__NETWORK_ERROR = ERROR_MESSAGE__NETWORK_ERROR;
exports.ERROR_MESSAGE__PAYMENT_ERROR = ERROR_MESSAGE__PAYMENT_ERROR;
exports.ERROR_MESSAGE__PAYMENT_GATEWAY_ERROR = ERROR_MESSAGE__PAYMENT_GATEWAY_ERROR;
exports.ERROR_MESSAGE__PAYMENT_GATEWAY_FIELDS = ERROR_MESSAGE__PAYMENT_GATEWAY_FIELDS;
exports.ERROR_MESSAGE__SERVER_ERROR = ERROR_MESSAGE__SERVER_ERROR;
exports.REQUIRED_VARIABLES = REQUIRED_VARIABLES;
exports["default"] = getEnv$1;
